import React from "react";
import "./bannerSection.css";
import arrowImage from "../../images/arrow-image.svg";
import ScrollReveal from "../scrollReveal/scrollReveal";
import config from "../../config";

const BannerSection = () => {
  const handleBookDemoClick = () => {
    window.location.href = config.bookdemo.Link;
  };

  return (
    <ScrollReveal>
      <section className="banner-section">
        <div className="banner-content">
          <h3>AI trustworthiness for AI Systems</h3>
          <h1>Managing AI Quality and Risks with Agentic AI Trust Score</h1>
          <p>
            AgentRAI: Delivering trustworthy and safe Agentic AI systems for
            businesses with ethical guardrails, real time scoring, risk
            management, and quality assurance.
          </p>
          <div className="book-demo-button" onClick={handleBookDemoClick}>
            <span>Book Demo</span>
            <img src={arrowImage} alt="arrow Icon" />
          </div>
        </div>
      </section>
    </ScrollReveal>
  );
};

export default BannerSection;
